import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
    
    state: {
        apis: [],
        reports: {},
        manager: {},
        campanas: {},
        configuracion: {},
        encuestas: {},
        whatsapp: {},
        facturacion: {},
        crm: {},
    },
    mutations: {
        setAPI(state, api) {
            // Agregando grupos de apis a items
            state.reports.items = api.reports;
            // state.manager.items = api.manager;
            state.campanas.items = api.campanas;
            state.configuracion.items = api.configuracion;
            state.encuestas.items = api.encuestas;
            state.whatsapp.items = api.whatsapp;
            state.facturacion.items = api.facturacion;
            // state.crm.items = api.crm;

            // console.log(state.manager);

            // Configurate title each API for Sidebar
            state.reports.title = "API Reportes";
            // state.manager.title = "API Reportes Manager";
            state.campanas.title = "API Campañas";
            state.configuracion.title = "API Configuración";
            state.encuestas.title = "API Encuesta";
            state.whatsapp.title = "API WhatsApp";
            state.facturacion.title = "API Facturación";
            // state.crm.title = "API CRM Wolkvox";

            // Configurate link each API for Sidebar
            state.reports.link = "reportes";
            // state.manager.link = "manager";
            state.campanas.link = "campana";
            state.configuracion.link = "configuracion";
            state.encuestas.link = "encuesta";
            state.whatsapp.link = "whatsapp";
            state.facturacion.link = "facturacion";
            // state.crm.link = "crm";

            // Add each group Api to APis
            state.apis.push(state.reports);
            // state.apis.push(state.manager);
            state.apis.push(state.campanas);
            state.apis.push(state.configuracion);
            state.apis.push(state.encuestas);
            state.apis.push(state.whatsapp);
            state.apis.push(state.facturacion);
            // state.apis.push(state.crm);
        },
        setAPIManager(state, api) {
            state.manager.items = api;
            state.manager.title = "API Reportes Manager";
            state.manager.link = "manager";
            state.apis.push(state.manager);
        },
        setAPICrmW(state, api) {
            state.crm.items = api;
            state.crm.title = "API CRM Wolkvox";
            state.crm.link = "crm";
            state.apis.push(state.crm);
        },
    },
    actions: {

        async setAPIManager({ commit }) {
            try {
                return await fetch(
                        "https://wolkvox.com/documentation-apis/Controller/Controller-apis-manager.php"
                    )
                    // await fetch("http://localhost/Backend-Apis/pruebas-apis.php")
                    .then((res) => res.json())
                    .then((api) => {
                        // console.log(api);
                        commit("setAPIManager", api);
                    });
            } catch (error) {
                console.error(error);
            }
        },
        async setAPI({ commit }) {
            try {
                return await fetch(
                        "https://wolkvox.com/documentation-apis/Controller/pruebas-apis.php"
                    )
                    // await fetch("http://localhost/Backend-Apis/pruebas-apis.php")
                    .then((res) => res.json())
                    .then((api) => {
                        // console.log(api);
                        commit("setAPI", api);
                    });
            } catch (error) {
                console.error(error);
            }
        },
        async setAPICrmW({ commit }) {
            try {
                return await fetch(
                        "https://wolkvox.com/documentation-apis/Controller/Controller-apis-CrmW.php"
                    )
                    // await fetch("http://localhost/Backend-Apis/pruebas-apis.php")
                    .then((res) => res.json())
                    .then((api) => {
                        // console.log(api);
                        commit("setAPICrmW", api);
                    });
            } catch (error) {
                console.error(error);
            }
        },
    },
    modules: {},
});
export default store;
store.dispatch("setAPIManager");
store.dispatch("setAPI");
store.dispatch("setAPICrmW");